import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import * as Yup from 'yup';
import { IconButton } from '@mui/material';
import Icons from '../../../components/icons';
import { GradeRow, YearEntry } from '../types/AcademicYearTypes';

const parseAcademicYearResponse = (data: any): YearEntry[] => {
  if (!data?.academicYearDates) return [];
  return Object.entries(data.academicYearDates).map(([year, range]: any) => ({
    grade: data.grade,
    yearKey: year,
    startDate: range.startDate,
    endDate: range.endDate,
    _id: range._id
  }));
};

const getAcademicYearColumns = (
  isLoading: boolean,
  openEdit: (row: GradeRow) => void
): GridColDef[] => [
  { field: 'grade', headerName: 'Grade', flex: 1 },
  { field: 'startDateDisplay', headerName: 'Start Date', flex: 1 },
  { field: 'endDateDisplay', headerName: 'End Date', flex: 1 },
  {
    field: 'actions',
    headerName: 'Edit',
    flex: 0.5,
    sortable: false,
    filterable: false,
    align: 'right',
    headerAlign: 'right',
    width: 100,
    renderCell: (params: { row: GradeRow }) =>
      React.createElement(
        IconButton,
        {
          onClick: () => openEdit(params.row),
          disabled: isLoading,
          size: 'small'
        },
        React.createElement(Icons.EditBlackOutlined, null)
      )
  }
];

const mapYearEntriesToGridRows = (
  entries: YearEntry[],
  appliedAcademicYear: string | null
) => {
  if (!appliedAcademicYear) return [];
  return entries
    .filter((e) => e.yearKey === appliedAcademicYear)
    .map((e) => ({
      id: e.grade,
      grade: e.grade,
      startDate: e.startDate,
      endDate: e.endDate,
      startDateDisplay: (e.startDate || '').slice(0, 10),
      endDateDisplay: (e.endDate || '').slice(0, 10),
      yearKey: e.yearKey,
      entryId: e._id
    }));
};

const academicYearSchema = Yup.object({
  startDate: Yup.date()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .required('Start date is required'),
  endDate: Yup.date()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .required('End date is required')
    .test(
      'is-after-start',
      'End date must be after the start date',
      function (value) {
        const { startDate } = this.parent;
        if (!value || !startDate) return true;
        return new Date(value).getTime() > new Date(startDate).getTime();
      }
    )
});

export {
  parseAcademicYearResponse,
  getAcademicYearColumns,
  mapYearEntriesToGridRows,
  academicYearSchema
};
